import $ from 'jquery';

export default function initTabModules() {
	$('.container-tab-module:not(.wp-block-taoti-tab-block-g) .tab').on('click keydown', function (e) {
		if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
			return;
		}
		e.preventDefault();
		const target = $(this).attr('attr-target');
		if (!target) {
			return;
		}
		const groupId = target.split('-')[0];
		$(`#tabs-${groupId} .tab`).removeClass('active');
		$(`#tab-${target}`).addClass('active');
		$(`#tab-content-${groupId} .content`).removeClass('active');
		$(`#content-${target}`).addClass('active');
	});

	$('.wp-block-taoti-tab-block-g').each(function () {
		const $block = $(this);
		const $tabsCol = $block.find('.col-tabs').first();
		const $contentCol = $block.find('.col-tab-content').first();
		if (!$tabsCol.length || !$contentCol.length) {
			return;
		}

		$contentCol.children('.wp-block-taoti-tab-panel-g, .tab-panel-g').each(function () {
			const $panel = $(this);
			const $tabBtn = $panel.children('.tab').first();
			const $content = $panel.children('.content').first();
			if ($tabBtn.length && $content.length) {
				$tabsCol.append($tabBtn);
				$content.insertBefore($panel);
				$panel.remove();
			}
		});

		if (!$block.find('.col-tabs .tab.active').length) {
			$block.find('.col-tabs .tab').first().addClass('active');
			$block.find('.col-tab-content > .content').first().addClass('active');
		}

		$block.find('.col-tabs .tab').off('click.taotiTabs keydown.taotiTabs');
		$block.find('.col-tabs .tab').on('click.taotiTabs keydown.taotiTabs', function (evt) {
			if (evt.type === 'keydown' && evt.key !== 'Enter' && evt.key !== ' ') {
				return;
			}
			evt.preventDefault();
			const attrTarget = $(this).attr('attr-target');
			if (!attrTarget || !$block.length) {
				return;
			}
			$block.find('.col-tabs .tab').removeClass('active');
			$(this).addClass('active');
			$block.find('.col-tab-content .content').removeClass('active');
			$block.find(`#content-${attrTarget}`).addClass('active');
		});
	});
}
